$(document).ready(function () {
    $('.materialboxed').materialbox();
});
$(function () {
    //Keycodes
    const TAB = 9,
        ESCAPE = 27,
        LEFT = 37,
        UP = 38,
        RIGHT = 39,
        DOWN = 40;

    /**
     * Clicking outside the menu:
     * Detect all clicks on the document and close any open submenu element
     */
    $(document).on('click', function (e) {
        // If user clicks inside the 'submenu', do nothing
        if (e.target.closest(".slinky-container")) return;
        // If Not, let's close the 'submenu'
        $('ul.menu li').removeClass('focus');
        $('.slinky-container').attr('aria-expanded', 'false')
    });

    /**
     * Arrow Keys Events
     */
    $(document).on('keydown', function (e) {
        //If LEFT or RIGHT is pressed within 'submenu' we jump back to the top level link
        if (e.target.closest('.slinky-container')) {
            if (e.keyCode === RIGHT || e.keyCode === LEFT) {
                let backToTopLevel = e.target.closest('.slinky-container');
                let topLevel = $(backToTopLevel).prev('a.menu-link');
                topLevel.focus();
            }
        }
    });

    let topLevelLinks = $('.nav-slinky .menu-link');
    let topLevelLink;

    //OnHover
    $('ul.menu li a').on('mouseenter', function () {
        console.log('test');
        $('ul.menu li').removeClass('focus');
        $('ul.menu li a').blur();
    });

    $.each(topLevelLinks, function (i, topLevelLink) {
        //On Hover (just updating Aria Labels - CSS is used to handle the hoverover)

        //FOCUS event
        $(topLevelLink).on('focus', function () {
            $(this).parent().addClass('focus');
            if (this.nextElementSibling !== null) {
                this.nextElementSibling.setAttribute('aria-expanded', 'true');
            }
        });

        //On KeyPress
        $(topLevelLink).on('keydown', function (e) {
            var code = e.keyCode || e.which;

            /**
             * SHIFT+TAB
             */
            if (e.shiftKey && e.keyCode === TAB) {
                $(this).parent().removeClass('focus');
            }

            //On Right Arrow Key
            if (e.keyCode === RIGHT) {
                let getParent = $(this).parent();

                console.log('getParent', getParent);
                console.log('parent next ', $(getParent).next());

                if ($(getParent).next().length != 0) {
                    let nextTopLevelLink = getParent.next();
                    console.log('nextTopLevelLink', nextTopLevelLink);

                    $(getParent).removeClass('focus');
                    $(getParent).find('.slinky-container').attr('aria-expanded', 'false');
                    $(nextTopLevelLink).addClass('focus');
                    $(nextTopLevelLink).find('.slinky-container').attr('aria-expanded', 'true');

                    let child = $(nextTopLevelLink).find('.menu-link');
                    $(child).focus();
                } else {
                    return;
                }
            }
            //On Left Arrow Key
            if (e.keyCode === LEFT) {
                let getParent = $(this).parent();

                console.log('getParent', getParent);

                if ($(getParent).prev().length != 0) {
                    let prevTopLevelLink = getParent.prev();
                    console.log('prevTopLevelLink', prevTopLevelLink);

                    $(getParent).removeClass('focus');
                    $(getParent).find('.slinky-container').attr('aria-expanded', 'false');
                    $(prevTopLevelLink).addClass('focus');
                    $(prevTopLevelLink).find('.slinky-container').attr('aria-expanded', 'true');

                    let child = $(prevTopLevelLink).find('.menu-link');
                    $(child).focus();
                } else {
                    return;
                }
            }

        });
    })
    //Selectbox ID
    $('.mixitup-filter-controls').find('fieldset').each(function () {
        let selectID = $(this).find('label').attr('for');
        $(this).find('.select-wrapper').children('input').attr('id', selectID);
    });
});

$('[class^="icon-"], [class*=" icon-"]').each(function () {
    var $this = $(this);

    if ($this.hasClass('icon-link')) {
        $('<i class="fal fa-chevron-double-right"></i>').appendTo($this);
    } else if ($this.hasClass('icon-media-pdf')) {
        $('<i class="fas fa-file-pdf" title="PDF Available"></i>').appendTo($this);
    } else if ($this.hasClass('icon-media-video')) {
        $('<i class="fas fa-video" title="Video Available"></i>').appendTo($this);
    } else if ($this.hasClass('icon-media-audio')) {
        $('<i class="fas fa-podcast" title="Audio Available"></i>').appendTo($this);
    }
    else { }
});

//slinky menu
$('.slinky-menu').each(function () {
    $(this).slinky({
        'title': 'parent'
    });
});

/* Can't get slinky methods to work.
    Resetting height restriction after resize */
var mobileSlinky = $('#slide-out .slinky-menu');
var globalNavigation = $('#global-navigation');
$(window).on('load windowResizeEnd', function () {
    mobileSlinky.css({
        'height': 'auto',
    });

    mobileSlinky.css({
        'height': mobileSlinky.outerHeight() + globalNavigation.outerHeight()
    });
});

//Global Navigation & Fund Header scrolling controls
if ($('#page-header.sticky-header').length === 0) {
    var globalNav = $('#global-navigation');
    var headerHeight = globalNav.height();
    var stickyNav = globalNav.offset().top + headerHeight;

    var sticky = function () {
        var scrollTop = $(window).scrollTop();

        if (scrollTop > stickyNav) {
            $('#global-navigation').addClass('active');
        }
        else {
            $('#global-navigation').removeClass('active');
        }
    };
    sticky();

    $(window).scroll(function () {
        sticky();
    });
}
else {
    var sticky = function () {
        var scrollTop = $(window).scrollTop();
        var headerHeight = $('#page-header.sticky-header').height();
        var stickyHeader = $('#page-header.sticky-header').offset().top;
        $('#global-navigation').addClass('header-sticky');

        if (scrollTop > stickyHeader) {
            $('#page-header.sticky-header').addClass('active');
        }
        else {
            $('#page-header.sticky-header').removeClass('active');
        }
    };
    sticky();

    $(window).scroll(function () {
        sticky();
    });
}

// Full Background Image
/// Add new tag with image applied as background element
$('.full-bg-img').each(function () {
    var newDiv = '<span class="bg-img"></span>';
    var imgContent = $(this).children('img').attr("src");

    if ($(this).find('img').length) {
        $(newDiv).css('background-image', 'url("' + imgContent + '")').appendTo(this);
    }

});


//responsive iframes and images
$("iframe:not(iframe#htmlContent, iframe[id*='frame-one'], iframe.highcharts-iframe, iframe.podcast)").each(function (i) {
    if (!$(this).parent().hasClass("video-container")) {
        $(this).wrap("<div class='video-container' />");
    }
});

$('#primary ul:not([class])').addClass("browser-default");

// News Article Share Button
$('button.share').click(function () {
    $(this).toggleClass('active');
    $('.Toolbox').toggleClass('visible');
});

//News grid
$('#NewsGridTable tr td:first-of-type a').append('<i class="fas fa-chevron-circle-right"></i>');


// Magnific PopUps (Modals)
/////bios
$('.bioPopUp').magnificPopup({
    type: 'ajax',
    preloader: false,
    removalDelay: 300,
    fixedContentPos: false,
    callbacks: {
        open: function () {
            jQuery('body').css('overflow-y', 'hidden');
        },
        close: function () {
            jQuery('body').css('overflow-y', '');
        }
    }
});

/////images
$('.modal-img, .gallery-item').magnificPopup({
    type: 'image',
    gallery: {
        enabled: false
    },
    removalDelay: 300,
    fixedContentPos: false,
    callbacks: {
        open: function () {
            jQuery('body').css('overflow', 'hidden');
        },
        close: function () {
            jQuery('body').css('overflow', '');
        }
    }
});

/////images
$('.modal-gallery a').magnificPopup({
    type: 'image',
    gallery: {
        enabled: true
    },
    removalDelay: 300,
    fixedContentPos: false,
    callbacks: {
        open: function () {
            jQuery('body').css('overflow', 'hidden');
        },
        close: function () {
            jQuery('body').css('overflow', '');
        },
        buildControls: function () {
            // re-appends controls inside the main container
            this.contentContainer.find('div.mfp-arrows').append(this.arrowLeft.add(this.arrowRight));
        }
    }
});

/////images
$('.video-gallery a').magnificPopup({
    type: 'iframe',
    gallery: {
        enabled: true
    },
    removalDelay: 300,
    fixedContentPos: false,
    callbacks: {
        open: function () {
            jQuery('body').css('overflow', 'hidden');
        },
        close: function () {
            jQuery('body').css('overflow', '');
        },
        buildControls: function () {
            // re-appends controls inside the main container
            this.contentContainer.find('div.mfp-arrows').append(this.arrowLeft.add(this.arrowRight));
        }
    }
});


//materialize jQuery components

var sideNav = $('.sidenav');
var sideNavClose = $('.sidenav-close');
var navLinks = $('.sidenav a').not(".sidenav a.next, .sidenav a.back");
var sideNavTrigger = $('.sidenav-trigger');
var searchTrigger = $('.search-trigger');
sideNav.sidenav({
    onOpenStart: function () {
        sideNavTrigger.attr('aria-expanded', 'true');
        sideNav.addClass('sidenav-active');
        sideNavClose.toggleClass('active');
        sideNavTrigger.toggleClass('inactive');
        searchTrigger.toggleClass('inactive');

        // Trap into sub menu
        if (sideNav.find('.menu-sub.active').length) {
            sideNav.find('.menu-sub.active').trapKeyboardActiveMenu();
        } else {

            // Trap into first level
            sideNav.trapKeyboardActiveMenu({
                'firstTabbableElement': sideNavClose,
                'lastTabbableElement': sideNav.find('.menu:first > li:last > a')
            });
        }
    },
    onCloseStart: function () {
        sideNavTrigger.attr('aria-expanded', 'false');
        sideNavClose.toggleClass('active');
        sideNavTrigger.toggleClass('inactive');
    },
    onCloseEnd: function () {
        sideNav.removeClass('sidenav-active');
        searchTrigger.toggleClass('inactive');
    }
}).each(function (index) {
    var $navMobile = $(this);

    $navMobile
        .find('.back')
        .each(function () {
            $(this)
                .closest('.header')
                .prependTo($(this).closest('ul'));
        });

    // Add and toggle proper attributes to next/back buttons
    $navMobile
        .find('.next')
        .each(function (index) {
            $(this)
                .attr({
                    'aria-expanded': 'false',
                    'role': 'button',
                    'aria-controls': 'mobileMenuSub' + index
                })
                .siblings('.menu-sub')
                .attr('id', 'mobileMenuSub' + index);
        })
        .on('click', function (e) {
            $(this).toggleAttrBoolean('aria-expanded');
            setTimeout(function () {
                $navMobile.find('.menu-sub.active').trapKeyboardActiveMenu();
            }, 300);
        })
        .end()
        .find('.back')
        .attr('role', 'button')
        .on('click', function () {
            // Back button toggle parent next button attribute
            $(this)
                .closest('.menu-sub')
                .siblings('.next')
                .toggleAttrBoolean('aria-expanded');

            // currentFocus.focus();
        });
});
//Close sideNav off button or of link trigger
sideNavClose.add(navLinks).on('click', function () {
    sideNav.sidenav('close');
    sideNavTrigger.focus();
});






// If top bar is compressed and keyboard focuses into utility items, expand top bar
$('#global-navigation').on('keyup', function (e) {
    if ($(document.activeElement).closest('#utility-nav').length) {
        $(this).removeClass('active');
    } else if ($(window).scrollTop() >= $(this).outerHeight()) {
        $(this).addClass('active');
    }
});

//Dropdown
$(".dropdown-trigger:not(.dropdown-trigger.search-trigger)").dropdown({
    constrainWidth: true,
});

/// Dropdown for Search
var searchTrigger = $(".search-trigger");
searchTrigger.dropdown({
    coverTrigger: false,
    closeOnClick: false,
    constrainWidth: false,
    onOpenStart: function () {
        searchTrigger.attr('aria-expanded', 'true');
        $('.search-trigger').toggleClass('active').find('svg').toggleClass('fa-search fa-times');
        $('.sidenav-trigger').toggleClass('inactive');
    },
    onCloseStart: function () {
        searchTrigger.attr('aria-expanded', 'false');
        $('.search-trigger').toggleClass('active').find('svg').toggleClass('fa-times fa-search');
        $('.sidenav-trigger').toggleClass('inactive');
    }
});

//Selects
$('select').formSelect();

//Sliders
$('.slider:not(#page-header .slider)').slider({
    height: 480,
    interval: 6000,
    duration: 500
});

var pageHeaderSlider = $('#page-header .slider');

pageHeaderSlider.slider({
    height: 560,
    interval: 7000,
    duration: 750
});

// Can't find documentation on the slider being used, so using setTimeout
setTimeout(function () {

    // Assign proper attributes and screenreader text to bullet navigation
    pageHeaderSlider
        .find('.indicator-item')
        .each(function (index) {
            $(this)
                .attr({
                    'role': 'button',
                    'tabindex': '0',
                    'aria-label': 'Slide ' + (index + 1)
                });
        })
        .end()
        .find('.indicators')
        .wrapAll('<div class="slider-controls">');

    // Add pause button next to dots
    var pauseBtn = $(
        '<button class="slider-pause-button" type="button" aria-label="Pause">' +
        '<i class="fas fa-pause" aria-hidden="true"></i>' +
        '<i class="fas fa-play" aria-hidden="true"></i>' +
        '</button>');

    pageHeaderSlider
        .find('.slider-controls')
        .prepend(pauseBtn);

    // Toggle pause/play click
    pauseBtn.on('click', function (e) {
        var $btn = $(this);

        $btn.toggleClass('paused');

        if ($btn.hasClass('paused')) {
            $btn.attr('aria-label', 'Play');
            pageHeaderSlider.slider('pause');
        } else {
            $btn.attr('aria-label', 'Pause');
            pageHeaderSlider.slider('start');
        }
    });

}, 300);

// Accordion / Collapsible
$('.collapsible:not(.expandable)').collapsible();
$('.expandable').collapsible({
    accordion: false
});

//DatePicker
$('.datepicker').datepicker({
    showClearBtn: true
});

//Timepicker
$('.timepicker').timepicker({
    showClearBtn: true
});

$('.monthpicker').monthpicker({
    showClearBtn: true
});



//Parallax
$('.parallax').parallax();

// Materialize Modal
//// best for in-page pop-up, not externally loaded


var cookieModal = $('#cookie-modal');
$('.modal').not(cookieModal).modal();

cookieModal.modal({
    opacity: 0,
    preventScrolling: false,
    dismissible: false,
    onOpenEnd: function () {
        $('#cookie-modal').next('.modal-overlay').remove();
    }
});



/// Carousel (images only)
$('.carousel-slider').carousel({
    fullWidth: true,
    indicators: true,
});

/// Thumbnail Carousel
$('.carousel:not(.carousel-slider)').carousel({
    indicators: true,
});

/// Set Carousels to auto-rotate
function autoplay() {
    $('.carousel.autoplay').carousel('next');
    setTimeout(autoplay, 8000);
}

autoplay();

// Tabs
$('.tabs').tabs({
    onShow: function () {
        $('.carousel').carousel();
    }
});

// for Tabbed Pages

// Remember the hash in the URL without jumping
$('a[data-toggle="tab"]:not("[target]")').click(function (e) {
    if (history.replaceState) {
        history.replaceState(null, null, '#' + $(e.target).attr('href').substr(1));
    } else {
        location.hash = '#' + $(e.target).attr('href').substr(1);
    }

    $(window).trigger('hashchange');
});

//// Advance indicator based on next click for tabs
$(".tab-pagination .btn-next").click(function () {
    $(this).closest(".tab-pagination").find(".tab-list").first().find(".tabs .tab").each(function () {
        if ($(this).find("a").hasClass("active")) {
            if ($(this).nextAll().hasClass("tab")) {
                $(this).next().find("a")[0].click();
                return false;
            }
        }
    });
});

//// Reverse indicator based on previous click for tabs
$(".tab-pagination .btn-prev").click(function () {
    $(this).closest(".tab-pagination").find(".tab-list").first().find(".tabs .tab").each(function () {
        if ($(this).find("a").hasClass("active")) {
            if ($(this).prevAll().hasClass("tab")) {
                $(this).prev().find("a")[0].click();
                return false;
            }
        }
    });
});

//// Change state of next & previous buttons for mobile view
$(".tabs .tab a").click(function () {
    $(this)[0].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
    }
    );
    if ($(this).parent().prevAll().hasClass("tab")) {
        $(this).closest(".tab-pagination").find(".btn-prev").first().prop("disabled", false);
        $(this).closest(".tab-pagination").find(".btn-prev").first().removeClass("disabled");
    } else {
        $(this).closest(".tab-pagination").find(".btn-prev").first().prop("disabled", true);
        $(this).closest(".tab-pagination").find(".btn-prev").first().addClass("disabled");
    }
    if ($(this).parent().nextAll().hasClass("tab")) {
        $(this).closest(".tab-pagination").find(".btn-next").first().prop("disabled", false);
        $(this).closest(".tab-pagination").find(".btn-next").first().removeClass("disabled");
    } else {
        $(this).closest(".tab-pagination").find(".btn-next").first().prop("disabled", true);
        $(this).closest(".tab-pagination").find(".btn-next").first().addClass("disabled");
    }
});

var cardSliderDefault = $('.card_slider.default');

cardSliderDefault.on('afterChange init setPosition', function (event, slick, direction) {
    var slidesActive = $(this).find('.slick-slide.slick-active');
    var slidesInactive = $(this).find('.slick-slide:not(.slick-active)');

    setTimeout(function () {
        slidesActive.each(function () {
            $(this).attr('tabindex', '0');
        });

        slidesInactive.each(function () {
            $(this).attr('tabindex', '-1');
        });
    }, 300);
});

// Slick Slider for Cards Default
cardSliderDefault.slick({
    variableWidth: true,
    centerMode: true,
    focusOnChange: true,
    infinite: true,
    accessibility: true,
    slidesToScroll: 1,
    rows: 1,
    swipe: true,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 959,
            settings: {
                slidesToShow: 1,
                variableWidth: false,
                centerMode: false,
            }
        }
    ],
    prevArrow: '<button class="slick-prev slick-arrow btn-floating" aria-label="Previous" type="button" style=""><i class="fal fa-arrow-left" aria-hidden="true"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow btn-floating" aria-label="Next" type="button" style=""><i class="fal fa-arrow-right" aria-hidden="true"></i></button>'
});

// Slick Slider for Wide Cards
$('.card_slider.wide-card').slick({
    variableWidth: false,
    infinite: true,
    centerMode: false,
    centerPadding: '100px',
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    swipe: true,
    swipeToSlide: true,
    dots: true,
    prevArrow: '<button class="slick-prev slick-arrow btn-floating" aria-label="Previous" type="button" style=""><i class="fal fa-arrow-left" aria-hidden="true"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow btn-floating" aria-label="Next" type="button" style=""><i class="fal fa-arrow-right" aria-hidden="true"></i></button>'
});

// METHOD: Toggle attribute true/false
$.fn.toggleAttrBoolean = function (elAttr) {
    $(this).attr(elAttr,
        $(this).attr(elAttr) === 'false' ? 'true' : 'false'
    );
};

// FUNCTION: Fire after window resize is done
var windowWidth = $(window).width();
$(window).on('resize', function () {
    var newWindowWidth = $(window).width();

    if (windowWidth !== newWindowWidth) {
        if (this.resizeTO) {
            clearTimeout(this.resizeTO);
        }
        this.resizeTO = setTimeout(function () {
            $(this).trigger($.Event('windowResizeEnd'));
        }, 150);
    }
    windowWidth = newWindowWidth;
});

$("a[href*=\\#]:not([href=\\#])").not("[data-toggle='tab'],.fund-docs, .card-tabs a").on('click', function (e) {
    e.preventDefault();

    var href = $(this).attr('href');

    // If href is not empty, starts with #, and is an element that exists on the page then scroll
    if (href && href.startsWith("#") && $(href).length) {
        // If tab, select that tab
        if (href.includes("horzTab") || href.includes("vertTab")) {
            $('.tabs').tabs();
            $('.tabs').tabs('select', href.split('#')[1]);
            // Scroll to anchor
        } else {
            $('html, body').animate({
                scrollTop: $(href).offset().top - 64,
            }, 1000, 'linear');
        }
        // Else it is an href to a different page, so redirect
    } else {
        window.location.href = href;
    }
});

//Variable Fixed Header Height
var fixedHeader;
$(window).on('resize', function () {
    if (windowWidth >= 960 && $('.header-fund').length) {
        fixedHeader = 183
    } else if (windowWidth >= 960 && $('.header-strategy').length) {
        fixedHeader = 156
    } else {
        fixedHeader = 64
    }
}).resize();

$("a[href*=\\#]:not([href=\\#])").not("[data-toggle='tab'], .card-tabs a, .dropdown-trigger").on('click', function (e) {
    e.preventDefault();

    var href = $(this).attr('href');
    var targ = $(this).attr('target')

    // Remove current page pathname from href to determine if hash link is on this page
    var hash = href.replace(window.location.pathname, '');
    // If hash is on this page update the href to hash so that tabbing works properly
    if (hash.indexOf('#') == 0) {
        href = hash;
        $(this).attr('href', href);
    }

    // If href is not empty, starts with #, and is an element that exists on the page then scroll
    if (href && href.startsWith("#") && $(href).length) {
        // If tab, select that tab
        if (href.includes("horzTab") || href.includes("vertTab")) {
            $('.tabs').tabs();
            $('.tabs').tabs('select', href.split('#')[1]);
            // Scroll to anchor
        } else {
            $('html, body').animate({
                scrollTop: $(href).offset().top - fixedHeader,
            }, 1000, 'linear');
        }
        // Else it is an href to a different page, so redirect
    } else {
        if (targ == '_blank') {
            window.open(href, targ);
        }
        else {
            window.location.href = href;
        }
        
    }
});

$('.fund-table tr').each(function (i) {
    $('td', this).each(function () {
        var value = $(this).html();
        if (value !== "" && value.trim() === "") {
            $(this).html("");
        }
    });
});

$('.detail-table tr').each(function (i) {
    $('td', this).each(function () {
        var value = $(this).html();
        if (value !== "" && value.trim() === "") {
            $(this).html("");
        }
    });
});

if (!$.cookie("rwbCookie")) {
    cookieModal.modal('open');

    $('#hide-banner').click(function () {
        $.cookie('rwbCookie', 'value', { expires: 365 });
    });
}
